import { useState, useEffect } from 'react';
import { generateBookOgCanvasImage, type BookOgImageOptions } from './ogCanvasGenerator.js';

/**
 * Custom hook to generate a dynamic branded OpenGraph image URL for a book showcase page
 */
export function useBookOgImage(book: BookOgImageOptions | null | undefined): string | undefined {
  const [ogImageUrl, setOgImageUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!book || !book.title || !book.uibn) {
      setOgImageUrl(undefined);
      return;
    }

    let isMounted = true;

    generateBookOgCanvasImage({
      title: book.title,
      uibn: book.uibn,
      authorName: book.authorName,
      publisherName: book.publisherName,
      category: book.category,
      publicationYear: book.publicationYear,
      coverUrl: book.coverUrl,
    })
      .then((dataUrl) => {
        if (isMounted && dataUrl) {
          setOgImageUrl(dataUrl);
        }
      })
      .catch(() => {
        if (isMounted) setOgImageUrl(undefined);
      });

    return () => {
      isMounted = false;
    };
  }, [
    book?.title,
    book?.uibn,
    book?.authorName,
    book?.publisherName,
    book?.category,
    book?.publicationYear,
    book?.coverUrl,
  ]);

  return ogImageUrl;
}
